import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { api } from '../../../_services/api.service';
import Loader from 'react-loaders';
import { formatDate } from '../../../_helpers/dateTimeHelper';
import { CustomInput, Row, Col } from 'reactstrap';

const DecisionNumberLineChart = ({ partnerScenarioId }) => {

    const intervals = [
        30, 60, 90, 180
    ];
    let [selectedInterval, setSelectedInterval] = useState(30);

    let [isLoading, setIsLoading] = useState(true);
    let [numDecisionsData, setNumDecisionsData] = useState([]);
    let [lineChartSeries, setLineChartSeries] = useState([{ data: [] }]);
    let [lineChartOptions, setLineChartOptions] = useState({
        chart: {
            height: '50px',
            type: 'line',
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        // title: {
        //     text: 'Decisions2',
        //     align: 'left'
        // },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            },
        },
        xaxis: {
            categories: []
        }
    })

    useEffect(() => {
        if (partnerScenarioId > 0) {
            load(selectedInterval);
        } else {
            setIsLoading(false);
        }
    }, [])

    const load = (interval) => {
        setIsLoading(true);
        api.getPartnerChartNumDecisions(partnerScenarioId, interval).then(data => {
            setIsLoading(false);
            data = data.map(x => { x.data = new Date(x.itemDate); return x; });
            data = data.sort((a, b) => a.date - b.date);
            setNumDecisionsData(data);
            populateLineChart(data);
        })
    }

    const populateLineChart = (list) => {
        let series = [];
        let data = { name: 'Decisions', data: [] };
        let options = {
            chart: {
                height: '50px',
                type: 'line',
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            title: {
                text: `Decisions made over time`,
                align: 'left'
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: []
            }
        };
        options.xaxis.categories = [];
        list.forEach(element => {
            data.data.push(element.numValue);
            options.xaxis.categories.push(formatDate(element.itemDate));
        });
        series.push(data);
        setLineChartSeries(series);
        setLineChartOptions(options);
    }

    return (
        <>
        {/* <Row>
        <Col md="12">
            <div className="apexcharts-title-text">Decisions made over the last {selectedInterval} days</div>
        </Col>
        </Row> */}


        {isLoading && <Loader style={{}} type="ball-pulse" active />}
        {numDecisionsData && numDecisionsData.length > 0 &&
          <Chart
            options={lineChartOptions}
            series={lineChartSeries}
            type="line"
            height="250px"
          />
        }

        <Row>
          <Col md="6">
            <div className="form-group">
              <label style={{ margin: '10px' }}>Show Last</label>
              <CustomInput type="select" id="backbilling" value={selectedInterval} style={{ width: '100px' }}
                name="backbilling" onChange={e => {
                  setSelectedInterval(e.target.value);
                  load(e.target.value);
                }}>
                {intervals.map(x => {
                  return <option key={'i' + x} value={x}
                  >{x}</option>
                })}
              </CustomInput>
              <label style={{ margin: '10px' }}> Days</label>
            </div>
          </Col>
        </Row>
        </>
    )
}

export default DecisionNumberLineChart;